(() => {
  const field = document.querySelector('[data-driver-name]');
  const dialog = document.querySelector('#bba-driver-picker');
  if (!field || !dialog) return;
  const idField = document.querySelector('[data-driver-id]');
  const brand = dialog.querySelector('[data-picker-brand]');
  const model = dialog.querySelector('[data-picker-model]');
  const useModel = dialog.querySelector('[data-picker-use-model]');
  const search = dialog.querySelector('[data-picker-search]');
  const results = dialog.querySelector('[data-picker-results]');
  const count = dialog.querySelector('[data-picker-count]');
  let records = null;
  let pending = null;
  const el = (tag, value) => { const node = document.createElement(tag); node.textContent = value; return node; };
  const chooseRecord = d => {
    field.value = `${d.brand} ${d.model}`;
    if (idField) idField.value = d.id;
    close();
  };
  const close = () => { dialog.hidden = true; field.setAttribute('aria-expanded','false'); };
  const populateModels = () => {
    model.replaceChildren(el('option', brand.value ? 'Choose a model' : 'Choose a brand first'));
    model.firstChild.value = '';
    model.disabled = !brand.value || !records;
    useModel.disabled = true;
    if (!records || !brand.value) return;
    for (const d of records.filter(item => item.brand === brand.value)) {
      const option = el('option', `${d.model} · ${d.size_in} in · ${d.impedance_label || `${d.coils} × ${d.ohms_per_coil} Ω`} · ${d.revision}`);
      option.value = d.id; model.append(option);
    }
    model.selectedIndex = 0;
  };
  const render = () => {
    if (!records) return;
    const query = search.value.trim().toLowerCase();
    const matches = records.filter(d => (!brand.value || d.brand === brand.value) &&
      (!query || `${d.brand} ${d.series} ${d.model} ${d.revision} ${d.size_in}`.toLowerCase().includes(query)));
    count.textContent = `${matches.length} matching speakers · ${records.length} records available`;
    results.replaceChildren();
    for (const d of matches.slice(0, 100)) {
      const row = el('div', ''); row.className = 'bba-picker-row';
      const choose = el('button', `${d.brand} ${d.model} · ${d.size_in} in · ${d.impedance_label || `${d.coils} × ${d.ohms_per_coil} Ω`} · ${d.revision} — Choose`);
      choose.type = 'button'; choose.className = 'bba-picker-choice';
      choose.addEventListener('click', () => chooseRecord(d));
      row.append(choose); results.append(row);
    }
    if (matches.length > 100) results.append(el('p', `Showing the first 100. Choose a brand or search to narrow ${matches.length} matches.`));
    if (!matches.length) results.append(el('p', 'No match yet. You can close this list and type your speaker manually.'));
  };
  const load = () => {
    if (records) return Promise.resolve();
    if (!pending) pending = fetch(field.dataset.catalogSource)
      .then(response => { if (!response.ok) throw new Error('Library unavailable'); return response.json(); })
      .then(data => {
        if (!Array.isArray(data.records)) throw new Error('Invalid library');
        records = data.records;
        for (const name of [...new Set(records.map(d => d.brand))].sort()) {
          const option = el('option', name); option.value = name; brand.append(option);
        }
        populateModels();
        render();
      }).catch(() => { pending = null; count.textContent = 'The library could not load. Close this list and type your speaker manually.'; });
    return pending;
  };
  const open = () => {
    if (!dialog.hidden) return;
    dialog.hidden = false; field.setAttribute('aria-expanded','true');
    load(); search.focus();
  };
  field.addEventListener('click', open);
  field.addEventListener('input', () => { if (idField) idField.value = ''; });
  dialog.querySelectorAll('[data-picker-close]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault(); close();
  }));
  dialog.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  brand.addEventListener('change', () => { populateModels(); render(); });
  model.addEventListener('change', () => {
    useModel.disabled = !model.value;
    const selected = records && records.find(d => d.id === model.value);
    if (selected) chooseRecord(selected);
  });
  useModel.addEventListener('click', () => {
    const selected = records && records.find(d => d.id === model.value);
    if (selected) chooseRecord(selected);
  });
  search.addEventListener('input', render);
})();
